import React, { useState } from 'react';
import './NewMeeting.css';

const NewGuestMeeting = ({ onBack, token }) => {
  const [formData, setFormData] = useState({
    meeting_agenda: '',
    location: '',
    date: '',
    time: '',
    attendee_name: '',
    attendee_phone: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.meeting_agenda || !formData.location || !formData.date || !formData.time || !formData.attendee_name) {
      setError('Please fill in all required fields');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');

      const apiUrl = `${process.env.REACT_APP_API_URL}/api/guests/add/meeting`;
      console.log('Submitting meeting to:', apiUrl);

      // Combine date and time into datetime format
      const datetime = `${formData.date} ${formData.time}`;

      const dataToSend = {
        meeting_agenda: formData.meeting_agenda,
        location: formData.location,
        datetime: datetime,
        attendee_name: formData.attendee_name,
        attendee_phone: formData.attendee_phone || null,
      };

      console.log('Form data:', dataToSend);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` }),
        },
        body: JSON.stringify(dataToSend),
      });

      console.log('API Response status:', response.status);

      const data = await response.json();
      console.log('API Response:', data);

      if (response.ok) {
        setSuccess('Meeting added successfully!');

        // Reset form
        setFormData({
          meeting_agenda: '',
          location: '',
          date: '',
          time: '',
          attendee_name: '',
          attendee_phone: '',
        });

        // Go back after 1.5 seconds
        setTimeout(() => {
          onBack();
        }, 1500);
      } else {
        setError(data.message || 'Failed to add meeting');
      }
    } catch (err) {
      console.error('Error adding meeting:', err);
      setError(err.message || 'Failed to add meeting');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="new-meeting-container">
      {/* Header */}
      <div className="meeting-form-header">
        <button className="back-button" onClick={onBack}>
          ←
        </button>
        <h2>New Meeting</h2>
      </div>

      {/* Status Messages */}
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      {/* Form */}
      <form onSubmit={handleSubmit} className="new-meeting-form">
        {/* Meeting Details Section */}
        <div className="form-section">
          <h3>Meeting Details</h3>

          <div className="form-group">
            <label>Meeting Agenda *</label>
            <input
              type="text"
              name="meeting_agenda"
              value={formData.meeting_agenda}
              onChange={handleInputChange}
              placeholder="Enter meeting agenda"
              required
            />
          </div>

          <div className="form-group">
            <label>Location *</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="Enter meeting location"
              required
            />
          </div>

          {/* Date and Time Section */}
          <div className="date-time-container">
            <div className="form-group date-time-group">
              <label>Select Date *</label>
              <div className="date-input-wrapper">
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  required
                />
                <span className="date-icon">📅</span>
              </div>
            </div>

            <div className="form-group date-time-group">
              <label>Select Time *</label>
              <div className="time-input-wrapper">
                <input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleInputChange}
                  required
                />
                <span className="time-icon">🕐</span>
              </div>
            </div>
          </div>
        </div>

        {/* Attendee Details Section */}
        <div className="form-section">
          <h3>Attendee Details</h3>

          <div className="form-group">
            <label>Attendee Name *</label>
            <input
              type="text"
              name="attendee_name"
              value={formData.attendee_name}
              onChange={handleInputChange}
              placeholder="Enter attendee name"
              required
            />
          </div>

          <div className="form-group">
            <label>Attendee Phone Number (Optional)</label>
            <input
              type="tel"
              name="attendee_phone"
              value={formData.attendee_phone}
              onChange={handleInputChange}
              placeholder="Enter attendee phone number"
            />
          </div>
        </div>

        {/* Submit Button */}
        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Adding Meeting...' : 'Add Meeting'}
        </button>
      </form>
    </div>
  );
};

export default NewGuestMeeting;
